module.exports = __webpack_public_path__ + "img/msg1.61b5a2a8.svg";